export default __webpack_public_path__ + "static/media/roadmap.af7ab5a3.png";